import { getDateRange } from 'src/Features/SelectedDatePeriod/predefinedDatePeriods'
import { getOrchestratedBendersAtLocations, getOrchestratedBendersWithIds } from 'src/Providers/OrchestratedBender'
import { useAppStateStore } from 'src/Store/appState'
import { useQueryWithErrorHandling } from './useQueryWithErrorHandling'
import type { AggregatedAssetParams } from 'src/Hooks/NetworkData/useAggregatedAssets'

export const useBendersWithAlarms = ({
  datePeriod,
  idType,
  ids,
  onlyWithAlarms = false,
  enableAllAlarmTypes = false,
  enabled = true,
}: AggregatedAssetParams) => {
  const lastUpdated = useAppStateStore(state => state.selectedDatePeriod.lastUpdated)

  const query = useQueryWithErrorHandling(
    ['bendersWithAlarms', { idType, ids, datePeriod, onlyWithAlarms, enableAllAlarmTypes, lastUpdated, enabled }],
    () => {
      if (!datePeriod || !enabled) {
        return []
      }
      const dateRange = getDateRange(datePeriod)
      if (idType === 'baneDataLocationIds') {
        return getOrchestratedBendersAtLocations(dateRange, ids, onlyWithAlarms, enableAllAlarmTypes)
      }

      return getOrchestratedBendersWithIds(dateRange, ids, onlyWithAlarms, enableAllAlarmTypes)
    },
    {
      enabled: ids.length > 0,
    },
    'benders.fetchError'
  )

  return {
    ...query,
    bendersWithAlarms: query.data,
  }
}
